import { uiRoutes } from '@consumer-frontend/api';
import { Link } from '@consumer-frontend/shared-ui';

import '@consumer-bootstrap/index.scss';
import '@consumer-bootstrap/pages/account-home/footer.scss';

export const DisclaimerText = () => {
  return (
    <div className="disclaimers">
      <p>
        *CashNetUSA is not a lender in all states. CashNetUSA and third-party lenders use various credit reports, data
        sources and application information as part of their underwriting. Not all applications are approved. Approval
        and loan terms vary based on applicant qualifications and by state. See
        &#32;
        <Link onDarkBg to={uiRoutes.ratesAndTerms}>Rates &amp; Terms</Link>
        &#32;
        for details. Decision may
        take longer if additional verification or documents are required.
      </p>

      <p>
        &dagger;Applications approved before 1:30 p.m. CT Monday-Friday are
        generally funded same business day, subject to your bank&apos;s processing times. Applications approved other times
        are generally funded the next business day. Some applications may
        require additional verification. In such cases, if approved, funds will be
        disbursed by the following business day after the additional verifications are complete.
      </p>

      <p>
        TX residents: CashNetUSA operates as a Credit Access Business (CAB) to
        arrange a loan between you and an unaffiliated third-party lender.
      </p>

      <p>
        KS residents: CashNetUSA, License No. SL.0000293
      </p>

      <p className="copyright">
        &copy; {new Date().getFullYear()} CNU Online Holdings, LLC. All Rights Reserved.
      </p>
    </div>
  );
};
